import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import moment from 'moment'
/*import {Button, Select} from 'element-ui'*/
import 'element-ui/lib/theme-chalk/index.css'

// 全局
import GLOBAL from "./global";

// 通过this.$Global.XXX可全局访问global/index.js中的常量或枚举
Vue.prototype.$Global = GLOBAL;

Vue.config.productionTip = false

// 全部使用
Vue.use(ElementUI)
//Vue.use(ElementUI, {size: 'small'})
/*
// 部分引用
Vue.component(Button.name, Button)
Vue.component(Select.name,Select)
Vue.use(Button)
Vue.use(Select)
*/
Vue.prototype.$moment = moment
Vue.filter('datetime', function (value) {
  if (!value) return ''
  value = value.toString()
  let format = 'YYYY-MM-DD'
  return moment(value).format(format)
})
Vue.filter('year', function (value) {
  if (!value) return ''
  value = value.toString()
  let format = 'YYYY'
  return moment(value).format(format)
})
Vue.filter('month', function (value) {
  if (!value) return ''
  value = value.toString()
  let format = 'MM-DD'
  return moment(value).format(format)
})

// 路由跳转前执行
router.beforeEach((to, from, next) => {
  // 页面置顶
  //document.body.scrollTop = 0
  // firefox
  //document.documentElement.scrollTop = 0
  // safari
  //window.pageYOffset = 0

  next();
})

router.afterEach(() => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
